// src/components/CookieBanner.jsx
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";
import { initFacebookPixel, trackEvent } from "../utils/pixel";

const CookieBanner = () => (
  <CookieConsent
    location="bottom"
    buttonText="Acceptera"
    declineButtonText="Endast nödvändiga"
    enableDeclineButton
    style={{
      background: "linear-gradient(90deg, #282c34, #347fa4, #282c34)",
      color: "white",
      fontSize: "16px",
      padding: "1rem",
    }}
    buttonStyle={{
      background: "#38B2AC", // turquoise
      color: "white",
      fontWeight: "bold",
      borderRadius: "4px", 
      padding: "8px 16px",
    }}
    declineButtonStyle={{
      background: "#fffcf5", // grå
      color: "#1A202C",
      borderRadius: "4px", 
      fontWeight: "bold",
      padding: "8px 16px",
    }}
    onAccept={() => {
      // Ge pixel-scriptet grönt ljus
      initFacebookPixel();
      // Berätta för Meta att vi fått ad_storage-samtycke
      if (window.fbq) {
        window.fbq('consent', 'grant', 'ad_storage');
      }
    }}
    onDecline={() => {
      // Dra tillbaka alla cookies för marknadsföring
      if (window.fbq) {
        window.fbq('consent', 'revoke', 'ad_storage');
      }
    }}
  >
    Vi använder cookies för att förbättra din upplevelse. Genom att klicka "Acceptera" godkänner du detta.
    Läs mer i vår{" "}
    <Link to="/integritetspolicy" className="underline text-blue-300">
      integritetspolicy
    </Link>.
  </CookieConsent>
);
export default CookieBanner;
